import { array, boolean, date, number, object, string } from "yup";

import {
  AbtestScenarioPageGroupDeliverUrlInput,
  AbtestScenarioPageGroupExcludeReferrerInput,
  AbtestScenarioPageGroupReferrerInput,
  AbtestScenarioPageGroupTargetCookieInput,
  AgeRange,
  AnnualIncome,
  Browser,
  DeliverDayOfWeekInput,
  DeliverKind,
  Device,
  Gender,
  Platform,
  VisitMatch,
} from "~/src/__generated__/schema";

export type FormValues = {
  ageRanges: AgeRange[];
  annualIncomes: AnnualIncome[];
  browsers: Browser[];
  deliverDayOfWeeks: DeliverDayOfWeekInput[];
  deliverExcludeUrls: AbtestScenarioPageGroupDeliverUrlInput[];
  deliverKind: DeliverKind;
  deliverTargetUrls: AbtestScenarioPageGroupDeliverUrlInput[];
  devices: Device[];
  endDate: Date | null;
  excludeReferrers: AbtestScenarioPageGroupExcludeReferrerInput[];
  funnelId: string;
  genders: Gender[];
  isContentAnalyticsEnabled: boolean;
  memo: string | null;
  pageId: string;
  platforms: Platform[];
  referrers: AbtestScenarioPageGroupReferrerInput[];
  repeat: boolean;
  startDate: Date | null;
  sourceIds: string[];
  targetCookies: AbtestScenarioPageGroupTargetCookieInput[];
  title: string;
  visitCount: number | null;
  visitMatchType: VisitMatch;
  excludeSourceIds: string[];
  scheduleIds: string[];
};

export const validationSchema = object({
  ageRanges: array().of(string()),
  annualIncomes: array().of(string()),
  browsers: array().of(string()),
  deliverKind: string().required(),
  devices: array().of(string()),
  endDatetime: date().nullable(),
  funnelId: string().required(),
  genders: array().of(string()),
  isContentAnalyticsEnabled: boolean().required(),
  memo: string().nullable(),
  pageId: string().required(),
  platforms: array().of(string()),
  repeat: boolean().required(),
  startDatetime: date().nullable(),
  sourceIds: array().of(string()),
  title: string().required().max(50),
  visitCount: number().nullable(),
  visitMatchType: string().required(),
  excludeSourceIds: array().of(string()),
  scheduleIds: array().of(string()),
});
